import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
		name: 'Home',
    component: Home
  },
  {
    path: '/cv',
    name: 'CV',
		meta: { layout: 'navbarless' },
    component: () => import('../views/CV.vue')
  },
  {
    path: '/case/:slug',
    name: 'case',
		meta: { layout: 'case' },
    component: () => import('../views/Case.vue')
  }
]

export default new VueRouter({
  routes
})
